import { LocalDatabaseService } from 'src/app/services/firestore/local-database.service';
import { RespNewIdea, RespUploadImage, RespGetMapList, RespGetMap, MMap, MMapIdea, RespAddMap } from '../../model/mindmeister.model';
import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpParams
} from '@angular/common/http';

import { Subject, firstValueFrom, lastValueFrom, throwError } from 'rxjs';
import { getDownloadURL, ref, getStorage } from 'firebase/storage';
import { TodoItemNode } from '../../model/notes.model';
import { SettingsService } from '../firestore/settings.service';


// TODO : linkar endereco da API do mindmeister , da autenticacao tmb

@Injectable({
  providedIn: 'root'
})
export class MindmeisterService {

  //error = new Subject<string>();

  maps : MMap[] = [];
  mapIdeas : MMapIdea[] = [];

  nodesToExport: number = 1;
  nodesExported: number = 0;
  rootMindmeisterIdeaExported = '';

  //coloca interceptor pra colocar o header
  // faz um observables para listar se der algum erro

  private storage = getStorage();

  constructor(private http: HttpClient, private localDb: LocalDatabaseService, private settingsService: SettingsService ) {
  }

  private getProxyAdress() {
    return this.settingsService.getCloudFunctionsUrl() + '/proxy';
  }

  clearProgressCounters() {
    this.nodesToExport = 1;
    this.nodesExported = 0;
  }

  getMapIdeas(mapId: string) {
    // Return newIdeaCreatedId

    this.mapIdeas = [];

    let searchParams = new HttpParams();

    //searchParams = searchParams.append('method', 'mm.maps.getMap');
    //searchParams = searchParams.append('map_id', mapId);

    const url = `https://www.mindmeister.com/services/rest/oauth2?method=mm.maps.getMap&map_id=${mapId}`;
    searchParams = searchParams.append('url', url);

    return new Promise((resolve, reject) => {

      this.http
        .get<{ rsp: RespGetMap }>(
          //'https://www.mindmeister.com/services/rest/oauth2',
          this.getProxyAdress(),
          {
            params: searchParams
          }
        ).subscribe(
          responseData => {
            //console.log((<RespNewIdea> responseData).rsp.id);
            //console.log("mandando imagem aaa");

            responseData.rsp.ideas.idea.forEach(element => {
              this.mapIdeas.push(
                {
                  id: element.id,
                  title: element.title
                });
            });

            //console.log(this.mapIdeas);
            //console.log("lenght: " + this.mapIdeas.length);

            resolve(this.mapIdeas);

          },
          error => {
            console.log(error.message);
            //this.error.next(error.message);
            //  ver para emitir erro e sair do fluxo de execução
            // ver como é feita a execução no promisse
            return reject(error);
            //reject(error);
          }
        );
    });
  }

  private getMapsListPagination(page: number) {

    let searchParams = new HttpParams();

    /*
    searchParams = searchParams.append('method', 'mm.maps.getList');
    searchParams = searchParams.append('per_page', 500);
    searchParams = searchParams.append('page', page);
    */

    //console.log("Chamou com PAGE NUMBER = " + page);

    const url =
      `https://www.mindmeister.com/services/rest/oauth2?method=mm.maps.getList&per_page=500&page=${page}`;
    searchParams = searchParams.append('url', url);

    return new Promise((resolve, reject) => {

    this.http
      .get<{rsp: RespGetMapList}>(
        //'https://www.mindmeister.com/services/rest/oauth2',
        this.getProxyAdress(),
        {
          params: searchParams
        }
      ).subscribe(
        responseData => {
          //console.log((<RespNewIdea> responseData).rsp.id);
          //console.log(`Lendo mensagem na chamada para page (${page}) e a page da resposta foi ${responseData.rsp.maps.page}`);
          //console.log(responseData);



          responseData.rsp.maps.map.forEach(element => {

            if (element.viewonly == 0) {
              this.maps.push(
                {
                  id: element.id,
                  title: element.title,
                  viewonly: element.viewonly
                });
            }
          });

          //console.log("tamanho da bagaça é: " + this.maps.length);

          console.log(this.maps);

          if ((+responseData.rsp.maps.page) < (+responseData.rsp.maps.pages)){
            this.getMapsListPagination(+responseData.rsp.maps.page + 1).then(a => {
              return resolve(this.maps);
            }).catch( error => {
              return reject(error);
            });
            //return this.getMapsListPagination(+responseData.rsp.maps.page + 1);
          }
         else {
           return resolve(this.maps);
         }
        },
        error => {
          console.log(error.message);
         // this.error.next(error.message);
          //  ver para emitir erro e sair do fluxo de execução
          // ver como é feita a execução no promisse

          return reject(error);
          //reject(error);
        }
      );

    });
  }

  getMapsList() {
    // Return newIdeaCreatedId
    // primeiro testa esse

    //console.log("chamou getMapsList()");
    this.maps = [];

    return this.getMapsListPagination(1);
  }

  /*
  getMapsList() {
    // Return newIdeaCreatedId
    // primeiro testa esse

    this.maps = [];

    let searchParams = new HttpParams();

    searchParams = searchParams.append('method', 'mm.maps.getList');
    searchParams = searchParams.append('per_page', 600);

    return new Promise((resolve, reject) => {

    this.http
      .get<{rsp: RespGetMapList}>(
        'https://www.mindmeister.com/services/rest/oauth2',
        {
          params: searchParams
        }
      ).subscribe(
        responseData => {
          //console.log((<RespNewIdea> responseData).rsp.id);
          console.log("mandando imagem aaa");
          console.log(responseData);

          responseData.rsp.maps.map.forEach(element => {
            this.maps.push(
              {
                id: element.id,
                title : element.title
              });
          });

          console.log("tamanho da bagaça é: " + this.maps.length);

          console.log(this.maps);

          return resolve(this.maps);

        },
        error => {
          console.log(error.message);
          this.error.next(error.message);
          //  ver para emitir erro e sair do fluxo de execução
          // ver como é feita a execução no promisse

          return reject(error);
        }
      );

    });
  }
  */

  uploadImage (mapId: string, ideaId: string, file: File) {

    // Post

    const formData = new FormData();

    formData.append("file", file);

    let searchParams = new HttpParams();
    /*
    searchParams = searchParams.append('method', 'mm.images.upload');
    searchParams = searchParams.append('map_id', mapId);
    searchParams = searchParams.append('idea_id', ideaId);
    */

    const url =
      `https://www.mindmeister.com/services/rest/oauth2?method=mm.images.upload&map_id=${mapId}&idea_id=${ideaId}`;
      searchParams = searchParams.append('url', url);

    const uploadObservable = this.http
      .post<{rsp: RespUploadImage}>(
        //'https://www.mindmeister.com/services/rest/oauth2',
        this.getProxyAdress(),
        formData,
        {
          params: searchParams
        }
      );

  return uploadObservable;
  }

  addNewIdea(mapId: string, parentId: string, title: string) {
    // Return newIdeaCreatedId
    // primeiro testa esse
    let searchParams = new HttpParams();

    /*
    searchParams = searchParams.append('method', 'mm.ideas.insert');
    searchParams = searchParams.append('map_id', mapId);
    searchParams = searchParams.append('parent_id', parentId);
    searchParams = searchParams.append('title', title);
    */

    // TODO -> se parent id e map id são os mesmos, manda x e y - coloca 0 e 0



    const url = (mapId === parentId) ?
      `https://www.mindmeister.com/services/rest/oauth2?method=mm.ideas.insert&map_id=${mapId}&parent_id=${parentId}&title=${title}&x_pos=200&y_pos=0`
      :`https://www.mindmeister.com/services/rest/oauth2?method=mm.ideas.insert&map_id=${mapId}&parent_id=${parentId}&title=${title}`;

      searchParams = searchParams.append('url', url);

    return this.http
      .post<{rsp: RespNewIdea}>(
        //'https://www.mindmeister.com/services/rest/oauth2',
        this.getProxyAdress(),
        null,
        {
          headers: {
            'Content-Type': 'application/json'
          },
          params: searchParams
        }
      );
  }

  addMap(title: string) {

    let searchParams = new HttpParams();

    const url =
      `https://www.mindmeister.com/services/rest/oauth2?method=mm.maps.add&title=${title}`;

      searchParams = searchParams.append('url', url);

    return this.http
      .post<{rsp: RespAddMap}>(
        //'https://www.mindmeister.com/services/rest/oauth2',
        this.getProxyAdress(),
        null,
        {
          headers: {
            'Content-Type': 'application/json'
          },
          params: searchParams
        }
      );
  }

  // NOT USED anymore
  uploadIdeasAndImages(mindMapId: string, ideaId: string, files: File[], position: number) {
    // Para cada file name - cria ideia - pra cada ideia criada manda o arquivo respectivo com o id da ideia criada junto

    if (position < files.length) {

      let file = files[position];

      this.addNewIdea(mindMapId, ideaId, file.name)
      .subscribe(
          responseData => {
            //console.log((<RespNewIdea> responseData).rsp.id);
            //console.log(responseData.rsp.id);

            this.uploadImage(mindMapId, responseData.rsp.id, file)
            .subscribe(
              responseData => {
                //console.log((<RespNewIdea> responseData).rsp.id);
                //console.log("mandando imagem aaa");
                //console.log(responseData.rsp.ideaimageid);

                this.uploadIdeasAndImages(mindMapId, responseData.rsp.ideaid, files, position + 1);
              },
              error => {
                //console.log(error.message);
                //this.error.next(error.message);
                //  ver para emitir erro e sair do fluxo de execução
                // ver como é feita a execução no promisse
              }
           );
          },
          error => {
            //console.log(error.message);
            //this.error.next(error.message);
          }
      );
    }
  }


  /* EXPORT FUNCTIONS */

  private async exportTree(nodeToExport: TodoItemNode, mindMapId: string, parentId: string) {


    return new Promise((resolve, reject) => {

      // TODO acho q o subscribe retorna mais de um valor, por isso fico fazendo recursivo
      const a = this.addNewIdea(mindMapId, parentId, nodeToExport.item).subscribe({
        next: async (responseData) => {

          a.unsubscribe();

          try {

            nodeToExport.mm_id = responseData.rsp.id;

            if (this.nodesExported == 0)
              this.rootMindmeisterIdeaExported = responseData.rsp.id;

            if (nodeToExport.image_path && nodeToExport.file) {

              const uploadObservable = this.uploadImage(mindMapId, nodeToExport.mm_id, nodeToExport.file);

              /* used for debug
              const uploadPromise = firstValueFrom(uploadObservable);


              uploadPromise.then(
                response => console.log('Promise resolved with', response),
                error => console.log('Promise rejected with', error),
              );

              const responseData = await uploadPromise;

              */

              let responseData = null;

              try {
                responseData = await firstValueFrom(uploadObservable);
              } catch (error) {
                console.error("Erro na primeira tentativa:", error);
                // Tentando novamente
                responseData = await firstValueFrom(uploadObservable);
              }

              // just for tests
              //throw new Error("teste - criando erro");

            }

            this.nodesExported++;


            // espera primeiro gravar nele
            if (nodeToExport.children) {

              for (const n of nodeToExport.children) {
                await this.exportTree(n, mindMapId, nodeToExport.mm_id);
              }
            }
            resolve('success');

          } catch (error) {
            //console.log(error);
            reject(error);
          }

        },
        error: (e) => {
          a.unsubscribe();
          //console.log(e);
          reject(e);
        }
      });
    });
  }


  async exportNodesToNewMindMeisterMAp(nodesToExport : TodoItemNode, mindMapId: string, parentId: string) {

    this.nodesExported = 1;

    if (nodesToExport.children) {
      for (const n of nodesToExport.children) {
        await this.exportTree(n, mindMapId, parentId);
      }
    }

    return Promise.resolve('success');
    //this.exportTree(nodesToExport, mindMapId, parentId);
 }

  exportNodesToMindMeister(nodesToExport : TodoItemNode, mindMapId: string, parentId: string) {
    this.nodesExported = 0;
    return this.exportTree(nodesToExport, mindMapId, parentId);
  }

  // ver pq em funcrion nao consigo acesssar variarve this ...
  private runTreeDownloadImages(node: TodoItemNode, myPromises: Promise<any>[]) {
    this.nodesToExport++;

    if (node.image_path) {
      // Cria uma promise para cada download
      const promise = new Promise<void>(async (resolve, reject) => {
        try {
          const storageRef = ref(this.storage, node.image_path);

          // Obtém o URL de download
          const downloadURL = await getDownloadURL(storageRef);
          node.imageDownloadUrl = downloadURL;

          // Faz o download do arquivo como blob
          const response = await fetch(downloadURL);
          if (!response.ok) {
            throw new Error(`Failed to fetch image: ${response.statusText}`);
          }

         // Converte Blob em File
        const blob = await response.blob();
        const fileName = node.image_path.split('/').pop() || 'unknown';
        node.file = new File([blob], fileName, { type: blob.type }); // Conversão para File
        node.fileName = fileName;

          resolve();
        } catch (error) {
          console.error('Error downloading image:', error);
          reject(error);
        }
      });

      // Adiciona a promise à lista
      myPromises.push(promise);
    }

    // Processa os filhos do nó
    if (node.children) {
      node.children.forEach((childNode) => {
        this.runTreeDownloadImages(childNode, myPromises);
      });
    }
  }

  async getNodesToExport(): Promise<TodoItemNode> {
    // Percorre e imprimir

    // pega numero total de nodes to export
    // atualiza depois num q ta sendo exportado
    // no vew divide o valor do numero exportado, pelo numero total

    let myPromisse: Promise<any>[] = new Array();

    this.nodesToExport = 0;

    this.runTreeDownloadImages((this.localDb.exportFromNode) ? this.localDb.exportFromNode : this.localDb.selectedNote, myPromisse);

    await Promise.all(myPromisse);

    return (this.localDb.exportFromNode) ? this.localDb.exportFromNode : this.localDb.selectedNote;
  }

}

 //[ok] - TODO - Ver bug quando salva na raiz - não funciona direito
      // "msg": "1st level ideas need to have an x_pos and y_pos"
        // ver api

 //[] - TODO Dialogs, como no figma - só o ui primeiro

 //[] - Todo, integrar código
  // dai manter em memória dos valores ou não por enquanto
 //[] - TODO - Fazer para criar um novo mapa, TMB

 //[] - UX - lógica  - para liberar - da pra ir fazendo
 //[] - Propgress bar e spinners
